'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isType = isType;
exports.isa = isa;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Corrected implementation of babel `isType` that works with node types
// added by `definePluginType`.
function isType(nodeType, targetType) {
  if (nodeType === targetType) return true;

  var aliases = _types2.default.FLIPPED_ALIAS_KEYS[targetType];
  if (aliases) {
    for (var _i3 = 0, _len3 = aliases.length; _i3 < _len3; _i3++) {
      var _e = aliases[_i3];if (nodeType === _e) return true;
    }
  }return false;
} // XXX: get this from somewhere else, does lodash have it?
function shallowEqual(objA, objB) {
  if (objA === objB) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var _i4 = 0, _len4 = keysA.length; _i4 < _len4; _i4++) {
    var _key = keysA[_i4];
    if (!bHasOwnProperty(_key) || objA[_key] !== objB[_key]) return false;
  }return true;
}
exports.default = function is(type, node, opts) {
  if (!node) return false;
  if (!isType(node.type, type)) return false;

  if (opts != null) return shallowEqual(node, opts);else return true;
}; // Flipped for use with lightscript ~ operator


function isa(node, type, opts) {
  if (!node) return false;
  if (!isType(node.type, type)) return false;

  if (opts != null) return shallowEqual(node, opts);else return true;
}